import {Typography} from "@mui/material";
import {currencyFormatter} from "../utils/numberFormatter";

export const MarketRate = ({value, type}) => {
  const percentageFormat = (value) => {
    // Perform the necessary formatting logic
    const formattedValue = `${value}%`;
    return formattedValue;
  };  
  let color = "";
  if (!isNaN(value)) {
    color = value > 0 ? "green" : "red";
  }

  if (type === "currency") return <Typography color={color}>{currencyFormatter(value)}</Typography>;
  if (type === "percentage") return <Typography color={color}>{percentageFormat(value)}</Typography>;

  return <Typography color={color}>{value > 0 ? `+${value}` : value}</Typography>;
};
